import React from "react";

export default function Panel({ id = null, primary = false, children, className = false }) {
  const totalClass = `panel${primary ? " panel-primary" : ""}${className ? ` ${className}` : ""}`;

  return (
    <div id={id ? id : ""} className={totalClass}>
      {children}
    </div>
  );
}
